class ProductRecommendations extends HTMLElement {
  loaded = false;

  connectedCallback() {
    this.loadRecommendations(this.dataset.productId);
  }

  loadRecommendations(productId) {
    if (this.loaded || !productId) return;
    this.loaded = true;

    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((error) => {
        this.loaded = false;
        console.error(error);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);
